export interface JwtPayload {
  permission_code?: number[];
  [key: string]: any;
}

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const decoded = atob(parts[1]);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Failed to decode JWT', error);
    return null;
  }
}

export function getPermissionsFromToken(token: string): number[] {
  const payload = decodeJwt(token);
  return payload?.permission_code ?? [];
}

export function hasPermission(token: string, permissionCode: number): boolean {
  const permissions = getPermissionsFromToken(token);
  return permissions.includes(permissionCode);
}

export function hasAnyPermission(token: string, permissionCodes: number[]): boolean {
  const permissions = getPermissionsFromToken(token);
  return permissionCodes.some(code => permissions.includes(code));
}

export function hasAllPermissions(token: string, permissionCodes: number[]): boolean {
  const permissions = getPermissionsFromToken(token);
  return permissionCodes.every(code => permissions.includes(code));
}
